// extracted by mini-css-extract-plugin
module.exports = {"contactsListCard":"ContactList_contactsListCard__1WQj_","hintMessage":"ContactList_hintMessage__11BUG bodySDefault"};